type Listener = (activeRequests: number) => void;

let requestCount = 0;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => listener(requestCount));
};

export const subscribeLoading = (listener: Listener) => {
  listeners.add(listener);
  listener(requestCount);
  return () => {
    listeners.delete(listener);
  };
};

export const startLoading = () => {
  requestCount += 1;
  notify();
};

export const stopLoading = () => {
  requestCount = Math.max(0, requestCount - 1);
  notify();
};
